import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { Icon as n } from "../Icon.js";
const d = ({ className: r, titleAccess: t }) => /* @__PURE__ */ e(
  n,
  {
    className: r,
    titleAccess: t,
    viewBox: "0 0 24 24",
    fill: "none",
    dataTestId: "close-button",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M20 4L4 20",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M4 4L20 20",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  d as IconClose
};
